import type React from "react";
import { type Ref, useState } from "react";
import type { Placement } from "react-aria";

import { Tooltip } from "./Tooltip";

type TooltipEllipsisProps = {
  text: string;
  offset?: number;
  placement?: Placement;
  children: (ref: Ref<HTMLHeadingElement> | undefined) => React.JSX.Element;
};

export const TooltipEllipsis = ({ text, offset = 0, placement = "bottom", children }: TooltipEllipsisProps) => {
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  const onContentRef = (ref: HTMLElement | null) => {
    if (ref) {
      setIsEllipsisActive(ref.offsetWidth < ref.scrollWidth);
    }
  };

  const content = children(onContentRef);

  if (isEllipsisActive) {
    return (
      <Tooltip
        text={text}
        placement={placement}
        offset={offset}
      >
        {content}
      </Tooltip>
    );
  }

  return content;
};
